// extracted by mini-css-extract-plugin
export default {"cal":"index_cal__41pqA","status1":"index_status1__eJW7l","status2":"index_status2__dOzpK","status3":"index_status3__6OwVG"};